module.exports = __webpack_public_path__ + "static/img/8.f0b8166.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/2/2/1/eng/8.png
// module id = JC0D
// module chunks = 0